import React from 'react';
import Navigation from '../components/Navigation';
import InterviewSession from '../components/InterviewSession';
import { getUserId } from '../utils/auth';
import env from '../config/environments';

const MARKETPLACE_URL = env.marketplaceUrl;

const ProfileInterview = () => {
    const userId = getUserId();

    const apiEndpoints = {
        fetch: `profile-interviews/`,
        start: `profile-interviews/start`,
        previewQuestion: `profile-interviews/preview_question/:questionNumber`,
        startQuestion: `profile-interviews/start_question/:questionNumber`,
        submitQuestion: `profile-interviews/submit_question/:questionNumber`,
        end: `profile-interviews/end`,
        proctor: `profile-interviews/proctor-events`
    };

    const profileUrl = `${MARKETPLACE_URL}/users/${userId}`;

    const navigationConfig = {
        backPath: profileUrl,
        backText: "Back to Profile",
        successPath: profileUrl,
        successButtonText: "Return to Profile",
        successMessage: "Profile interview completed successfully! You can now return to your profile page."
    };

    return (
        <>
            <Navigation />
            <InterviewSession
                interviewId="profile"
                workTrialId={null}
                apiEndpoints={apiEndpoints}
                navigationConfig={navigationConfig}
                interviewType="Profile Interview"
                showQuestionPreview={true}
            />
        </>
    );
};

export default ProfileInterview;
